export default {
	install(Vue) {
		Vue.mixin({
			created() {
				this.uniqueId = 'v' + this._uid;
			},
		});
	},
};
